export const LEGAL_PAGES = Object.freeze({
  "/privacy": {
    slug: "privacy",
    title: "Privacy e GDPR",
    description: "Come il sito informativo Il Consulente AI tratta e protegge i dati personali.",
  },
  "/termini": {
    slug: "termini",
    title: "Termini d’uso",
    description: "Condizioni per utilizzare il sito e raggiungere il percorso online XAISchool.",
  },
  "/ai-disclosure": {
    slug: "ai-disclosure",
    title: "Informativa AI",
    description: "Come viene presentata e utilizzata l’intelligenza artificiale nel percorso formativo.",
  },
  "/cookie": {
    slug: "cookie",
    title: "Cookie",
    description: "Cookie e tecnologie utilizzate dal sito informativo.",
  },
  "/note-legali": {
    slug: "note-legali",
    title: "Note legali",
    description: "Informazioni societarie e legali della verticale online Il Consulente AI.",
  },
  "/contatti": {
    slug: "contatti",
    title: "Contatti",
    description: "Parla con FreeFuture per informazioni o assistenza su Il Consulente AI.",
    showVersion: false,
  },
});

export const LEGAL_LINKS = Object.freeze([
  { href: "/privacy", label: "Privacy e GDPR" },
  { href: "/termini", label: "Termini" },
  { href: "/ai-disclosure", label: "Informativa AI" },
  { href: "/cookie", label: "Cookie" },
  { href: "/note-legali", label: "Note legali" },
  { href: "/contatti", label: "Contatti" },
]);

export function normalizeLegalPath(pathname = "/") {
  const cleanPath = pathname.split("?")[0].split("#")[0] || "/";
  if (cleanPath === "/") return cleanPath;
  return cleanPath.replace(/\/+$/, "");
}

export function legalPageForPath(pathname) {
  return LEGAL_PAGES[normalizeLegalPath(pathname)] || null;
}
